import { Component, OnInit, Input, ViewChild, ElementRef } from '@angular/core';
import { User } from 'src/app/models/user-model/user.model';
import { CompanyData } from 'src/app/models/company-data-model/company-data.model';
import { ValidationImageService } from 'src/app/services/validation-images-service/validation-image.service';
import { SpinnerService } from 'src/app/components/shared-components/spinner/spinner.service';
import { MatDialog } from '@angular/material/dialog';
import { ImageCropperDialogComponent } from 'src/app/components/shared-components/image-cropper-dialog/image-cropper-dialog.component';
import { SnackBarService } from 'src/app/components/shared-components/snack-bar/snack-bar.service';
import { UserService } from 'src/app/services/user-service/user.service';
import { CenterLite } from 'src/app/models/center-model/center-lite.model';

@Component({
  selector: 'app-account-header',
  templateUrl: './account-header.component.html',
  styleUrls: ['./account-header.component.scss']
})
export class AccountHeaderComponent implements OnInit {

  @ViewChild('uploadInput', { static: false }) uploadInput: ElementRef;
  @Input() user: User;
  @Input() centerList: CenterLite[];
  @Input() companyData: CompanyData;
  showSpinner: boolean;

  constructor(private validationImageService: ValidationImageService,
    private userService: UserService,
    private snackbarService: SnackBarService,
    private spinnerService: SpinnerService,
    public dialog: MatDialog) { }

  ngOnInit() {
    this.showSpinner = false;
  }

  public uploadAsset(event) {
    const file = event.target.files[0];
    const img = new Image();
    this.validationImageService.toBase64(file).subscribe(
      (base64) => {
        const dialogRef = this.dialog.open(ImageCropperDialogComponent, {
          data: { image: base64, width: 250, height: 250 }
        });
        dialogRef.afterClosed().subscribe(result => {
          if (result && this.user) {
            this.user.UserImage = result;
            this.showSpinner = true;
            this.spinnerService.show('account-user-image-spinner');
            this.userService.updateUserImage(this.user.InternalId, result).subscribe(
              (res) => {
                this.userService.refreshUser();
                this.showSpinner = false;
                this.spinnerService.hide('account-user-image-spinner');
                this.snackbarService.open('validation-images.snackbar messages.update image success', 'success');
              },
              (error) => {
                this.userService.refreshUser();
                this.showSpinner = false;
                this.spinnerService.hide('account-user-image-spinner');
                this.snackbarService.open(error['error']['message'], 'error');
              }
            );
          } else {
            this.userService.refreshUser();
            this.showSpinner = false;
            this.spinnerService.hide('account-user-image-spinner');
          }
        });
      },
      (error) => {
        this.userService.refreshUser();
        this.snackbarService.open(error, 'error');
      }
    );
  }

  public uploadPhotoClicker() {
    this.uploadInput.nativeElement.value = null;
    this.uploadInput.nativeElement.click();
  }

  public getRolesPills() {
    const rolesPills = new Array();
    this.centerList.forEach(
      (c) => {
        c.UserRoleInCenter.forEach(
          (r) => {
            rolesPills.push([c, r]);
          }
        );
      }
    );
    return rolesPills;
  }
}
